<template>
    <div class="content">
  
  <textarea   name="" v-model="text" @keyup="processChange()" id="custom__text__area" cols="30" rows="4"></textarea>
      <ul class="data__item"
        v-if="list">
            <li v-for="item in list" :key="item.id" @click="handleClickS(item.text)">{{item.title}}</li>

        </ul>
    </div>
</template>

<script>
import {apiCall, getTemplates} from '../../../apis/structures'
export default {
    props: {
      initialReason:String
    },
  watch:{
    Text:function(){
      this.$emit('text',this.text)
   
    }
    
  },
  data() {
    
    return {

    list:null,   
    text:'',

    processChange : this.debounce((e)=>this.saveInput(e)),
    };
  },

  methods: {
    handleClickS(param){
      this.$emit('text',param)
this.text=param
this.list=null;
console.log(this.text);
    },
  debounce (func, timeout = 300){
  let timer;
  return (...args) => {
    
    clearTimeout(timer);
    timer = setTimeout(() => { 
      timer=null
        func(...args)
    }, timeout);
 
  };
},
saveInput(){
 const data =  getTemplates(this.text).then(e=>{
     
   e.data.data.entities.length>0 && this.text!=""? this.list = e.data.data.entities : this.list=null;
   this.$emit('text',this.text)
 
     })
},

changeText(){

this.data = '';
}
  },
  created() {
    this.text= this.initialReason
  }
}
</script>


<style lang="scss" scoped src="./index.scss"></style>
